import CampaignDetails from './campaign_details'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { connect } from 'react-redux'

const mapStateToProps = (state, props) => {
  return {
    details: getCampaignSelector(state, props).description,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CampaignDetails)
